// extracted by mini-css-extract-plugin
export default {"disclosure":"disclosure-Aoh6s"};